// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCy3Q_8xjSJVSnYCCoDGQ0V4FMpi3Nv8H4",
  authDomain: "kvptradee.firebaseapp.com",
  projectId: "kvptradee",
  storageBucket: "kvptradee.firebasestorage.app",
  messagingSenderId: "13959897370",
  appId: "1:13959897370:web:4ce4b229a990d9ec97cca3",
  measurementId: "G-4F3YQ43PPG"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export {app, auth, analytics, db};